<template>
    <div class="position-relative d-flex pb-4 header">
        <div class="position-absolute start-50 translate-middle-x text-center d-none d-md-block">
            <h3 class="title">
                {{ $t("institution.invoicing.title") }}
            </h3>
        </div>
        <CancelPayment :institutionId="institutionId" v-if="institution.paying" class="ms-auto d-none d-md-block" />

        <!-- varianta pro malé displeje -->
        <h3 class="title text-center d-block d-md-none">
            {{ $t("institution.invoicing.title") }}
        </h3>
        <CancelPayment :institutionId="institutionId" v-if="institution.paying" class="mx-auto d-block d-md-none" />
    </div>
    <div class="row mt-4 g-2">
        <div class="col-12 col-md-6">
            <div class="box">
                <span class="me-2">{{ $t("institution.invoicing.paidFor") }}:</span>
                <span class="me-1">{{ institution.paid_users }}</span>
                <span v-if="institution.paid_users < 5">{{ $t("admin.usersSmall") }}</span>
                <span v-else>{{ $t("admin.usersSmall2") }}</span>
            </div>
        </div>
        <div class="col-12 col-md-6">
            <div class="box">
                <span class="me-2">{{ $t("institution.invoicing.paidTo") }}:</span>
                <i18n-d v-if="institution.paid_to" tag="span" :value="new Date(institution.paid_to)"></i18n-d>
            </div>
        </div>
    </div>
    <div class="invoices mt-3" style="max-height: 550px; overflow-y: auto;">
        <table class="table table-responsive table-hover w-100 mt-3">
            <thead class="table_head">
                <tr>
                    <th>{{ $t("institution.invoicing.invoiceNumber") }}</th>
                    <th>{{ $t("institution.invoicing.invoiceDueDate") }}</th>
                    <th>{{ $t("institution.invoicing.invoiceAmount") }}</th>
                    <th>{{ $t("institution.invoicing.invoicePaid") }}</th>
                </tr>
            </thead>
            <tbody class="align-middle">
                <tr v-if="invoices.length > 0" v-for="invoice in invoices" :key="invoice.id" class="align-middle">
                    <td>
                        <span class="download_inv" @click="downloadInv(invoice)">{{ invoice.trivi_id ?
                            invoice.trivi_id :
                            invoice.accounting_document_no }}</span>
                    </td>
                    <td>
                        <i18n-d v-if="invoice.due_date" tag="span" :value="new Date(invoice.due_date)"></i18n-d>
                        <span v-else></span>
                    </td>
                    <td>
                        <span>{{ invoice.total }} Kč</span>
                    </td>
                    <td>
                        <icon v-if="invoice.invoice_paid" class="icon_true" icon="True" />
                        <icon v-if="!invoice.invoice_paid" class="icon_false" icon="False" />
                    </td>
                </tr>
                <tr v-else>
                    <td colspan="4" class="text-center">
                        <span>{{ $t("institution.invoicing.noInvoices") }}</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import CancelPayment from '@/components/Institution/CancelPayment.vue'

export default {
    props: {
        institutionId: {
            type: Number,
            required: true
        }
    },
    components: {
        CancelPayment
    },
    data() {
        return {
            institution: {},
            invoices: [],
        }
    },
    created: function () {
        this.loadData();
    },
    methods: {
        loadData: function () {
            this.$store.getters.api.get(`/institution/${this.institutionId}/settings`).then(function (response) {
                this.institution = response.data.institution;
                this.invoices = response.data.invoices;
            }.bind(this));
        },
        downloadInv: function (inv) {
            this.$store.getters.api.get(`/institution/${this.institutionId}/invoice/${inv.id}/download`, {
                responseType: 'blob'
            }).then((response) => {
                if (response.data) {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = window.document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', inv.trivi_id + '.pdf' || 'downloaded document' + '.pdf');
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.loadData();
                }
            })
        }
    },
}
</script>

<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.title {
    font-size: clamp(24px, 3.2vw, 40px);
    color: $text;
    font-weight: 500;
    font-family: $font-heading;
}

.table-invoices {
    --bs-table-bg: transparent;
    --bs-table-color: $white;
}

.icon_true {
    color: green;
    stroke: green;
    width: 35px;
    height: 35px;
}

.icon_false {
    color: red;
    stroke: red;
    width: 35px;
    height: 35px;
}

.download_inv {
    text-decoration: underline;
    cursor: pointer;
    color: $purple;

    &:hover {
        color: $purple;
        font-weight: 500;
    }
}

@media (max-width: 800px) {
    .header {
        display: flex;
        flex-direction: column;
    }
}
</style>